{
  "CONTACT_PANEL": {
    "NOT_AVAILABLE": "無法使用",
    "EMAIL_ADDRESS": "電子信箱地址",
    "PHONE_NUMBER": "電話號碼",
    "IDENTIFIER": "識別碼",
    "COPY_SUCCESSFUL": "已成功複製到剪貼簿",
    "COMPANY": "公司",
    "LOCATION": "位置",
    "BROWSER_LANGUAGE": "瀏覽器語言",
    "CONVERSATION_TITLE": "對話詳細資訊",
    "VIEW_PROFILE": "查看個人檔案",
    "BROWSER": "瀏覽器",
    "OS": "作業系統",
    "INITIATED_FROM": "發起自",
    "INITIATED_AT": "發起於",
    "IP_ADDRESS": "IP 位址",
    "CREATED_AT_LABEL": "建立時間",
    "NEW_MESSAGE": "新訊息",
    "CALL": "通話",
    "CALL_INITIATED": "正在撥打聯絡人電話…",
    "CALL_FAILED": "無法撥打電話，請稍後再試。",
    "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
    "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
    "CLICK_TO_EDIT": "點擊以編輯",
    "VOICE_INBOX_PICKER": {
      "TITLE": "選擇語音收件匣"
    },
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "此聯絡人沒有關聯的歷史對話。",
      "TITLE": "歷史對話"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "聯絡人標籤",
        "ERROR": "無法更新標籤"
      },
      "CONVERSATION": {
        "TITLE": "對話標籤",
        "ADD_BUTTON": "新增標籤"
      },
      "LABEL_SELECT": {
        "TITLE": "新增標籤",
        "PLACEHOLDER": "搜尋標籤",
        "NO_RESULT": "查無標籤",
        "CREATE_LABEL": "建立新標籤"
      }
    },
    "MERGE_CONTACT": "合併聯絡人",
    "CONTACT_ACTIONS": "聯絡人操作",
    "MUTE_CONTACT": "封鎖聯絡人",
    "UNMUTE_CONTACT": "解除封鎖聯絡人",
    "MUTED_SUCCESS": "此聯絡人已成功封鎖。您將不會收到任何後續對話的通知。",
    "UNMUTED_SUCCESS": "此聯絡人已成功解除封鎖。",
    "SEND_TRANSCRIPT": "傳送對話記錄",
    "EDIT_LABEL": "編輯",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "自訂屬性",
      "CONTACT_LABELS": "聯絡人標籤",
      "PREVIOUS_CONVERSATIONS": "歷史對話",
      "NO_RECORDS_FOUND": "查無屬性"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "編輯聯絡人",
    "TITLE": "編輯聯絡人",
    "DESC": "編輯聯絡人資訊"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "刪除聯絡人",
    "TITLE": "刪除聯絡人",
    "DESC": "刪除聯絡人資訊",
    "CONFIRM": {
      "TITLE": "確認刪除",
      "MESSAGE": "您確定要刪除嗎？",
      "YES": "是，刪除",
      "NO": "不，保留"
    },
    "API": {
      "SUCCESS_MESSAGE": "聯絡人已成功刪除",
      "ERROR_MESSAGE": "無法刪除聯絡人，請稍後再試。"
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "送出",
      "CANCEL": "取消",
      "AVATAR": {
        "LABEL": "聯絡人頭像"
      },
      "NAME": {
        "PLACEHOLDER": "請輸入聯絡人全名",
        "LABEL": "全名"
      },
      "BIO": {
        "PLACEHOLDER": "請輸入聯絡人簡介",
        "LABEL": "簡介"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "請輸入聯絡人電子信箱",
        "LABEL": "電子信箱地址",
        "DUPLICATE": "此電子信箱已被其他聯絡人使用。",
        "ERROR": "請輸入有效的電子信箱地址。"
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "請輸入聯絡人電話號碼",
        "LABEL": "電話號碼",
        "HELP": "電話號碼須為 E.164 格式，例如：+886912345678 [+][國碼][區碼][電話號碼]。您可以從下拉選單中選擇國碼。",
        "ERROR": "電話號碼須為空白或符合 E.164 格式",
        "DIAL_CODE_ERROR": "請從列表中選擇國碼",
        "DUPLICATE": "此電話號碼已被其他聯絡人使用。"
      },
      "LOCATION": {
        "PLACEHOLDER": "請輸入聯絡人位置",
        "LABEL": "位置"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "請輸入公司名稱",
        "LABEL": "公司名稱"
      },
      "COUNTRY": {
        "PLACEHOLDER": "請輸入國家名稱",
        "LABEL": "國家名稱",
        "SELECT_PLACEHOLDER": "選擇",
        "REMOVE": "移除",
        "SELECT_COUNTRY": "選擇國家"
      },
      "CITY": {
        "PLACEHOLDER": "請輸入城市名稱",
        "LABEL": "城市名稱"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "請輸入 Facebook 使用者名稱",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "請輸入 Twitter 使用者名稱",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "請輸入 LinkedIn 使用者名稱",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "請輸入 Github 使用者名稱",
          "LABEL": "Github"
        }
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "聯絡人頭像已成功刪除",
        "ERROR_MESSAGE": "無法刪除聯絡人頭像，請稍後再試。"
      }
    },
    "SUCCESS_MESSAGE": "聯絡人儲存成功",
    "ERROR_MESSAGE": "發生錯誤，請重試"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "開始對話",
    "TITLE": "新的對話",
    "DESC": "傳送一則新訊息以開始新的對話。",
    "NO_INBOX": "找不到可與此聯絡人發起新對話的收件匣。",
    "FORM": {
      "TO": {
        "LABEL": "收件人"
      },
      "INBOX": {
        "LABEL": "透過收件匣",
        "PLACEHOLDER": "選擇來源收件匣",
        "ERROR": "請選擇一個收件匣"
      },
      "SUBJECT": {
        "LABEL": "主旨",
        "PLACEHOLDER": "主旨",
        "ERROR": "主旨不得為空"
      },
      "MESSAGE": {
        "LABEL": "訊息",
        "PLACEHOLDER": "在此填寫您的訊息",
        "ERROR": "訊息不得為空"
      },
      "ATTACHMENTS": {
        "SELECT": "選擇檔案",
        "HELP_TEXT": "將檔案拖放到此處，或點選選擇要附加的檔案"
      },
      "SUBMIT": "傳送訊息",
      "CANCEL": "取消",
      "SUCCESS_MESSAGE": "訊息已傳送！",
      "GO_TO_CONVERSATION": "查看",
      "ERROR_MESSAGE": "無法傳送！請重新嘗試。"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "社群檔案"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "新增自訂屬性",
    "COPY_SUCCESSFUL": "已成功複製到剪貼簿",
    "SHOW_MORE": "顯示所有屬性",
    "SHOW_LESS": "顯示較少屬性",
    "ACTIONS": {
      "COPY": "複製屬性",
      "DELETE": "刪除屬性",
      "EDIT": "編輯屬性"
    },
    "ADD": {
      "TITLE": "建立自訂屬性",
      "DESC": "為此聯絡人新增自訂資訊。"
    },
    "FORM": {
      "CREATE": "新增屬性",
      "CANCEL": "取消",
      "NAME": {
        "LABEL": "自訂屬性名稱",
        "PLACEHOLDER": "例如：shopify id",
        "ERROR": "無效的自訂屬性名稱"
      },
      "VALUE": {
        "LABEL": "屬性值",
        "PLACEHOLDER": "例如：11901 "
      },
      "ADD": {
        "TITLE": "建立新屬性",
        "SUCCESS": "屬性已成功新增",
        "ERROR": "無法新增屬性，請稍後再試"
      },
      "UPDATE": {
        "SUCCESS": "屬性已成功更新",
        "ERROR": "無法更新屬性，請稍後再試"
      },
      "DELETE": {
        "SUCCESS": "屬性已成功刪除",
        "ERROR": "無法刪除屬性，請稍後再試"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "新增屬性",
        "PLACEHOLDER": "搜尋屬性",
        "NO_RESULT": "查無屬性"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "選擇值",
          "SEARCH_INPUT_PLACEHOLDER": "搜尋值",
          "NO_RESULT": "查無結果"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "請輸入有效的值",
      "INVALID_URL": "無效的 URL",
      "INVALID_INPUT": "無效的輸入"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "合併聯絡人",
    "DESCRIPTION": "合併聯絡人以將兩個個人檔案合併為一個，包含所有屬性和對話。如有衝突，將以主要聯絡人的屬性為準。",
    "PRIMARY": {
      "TITLE": "主要聯絡人",
      "HELP_LABEL": "將被刪除"
    },
    "PARENT": {
      "TITLE": "要合併的聯絡人",
      "PLACEHOLDER": "搜尋聯絡人",
      "HELP_LABEL": "將被保留"
    },
    "SUMMARY": {
      "TITLE": "摘要",
      "DELETE_WARNING": "<strong>{primaryContactName}</strong> 的聯絡人資料將被刪除。",
      "ATTRIBUTE_WARNING": "<strong>{primaryContactName}</strong> 的聯絡人詳細資訊將被複製到 <strong>{parentContactName}</strong>。"
    },
    "SEARCH": {
      "ERROR_MESSAGE": "發生錯誤，請稍後再試。"
    },
    "FORM": {
      "SUBMIT": " 合併聯絡人",
      "CANCEL": "取消",
      "CHILD_CONTACT": {
        "ERROR": "請選擇要合併的子聯絡人"
      },
      "SUCCESS_MESSAGE": "聯絡人已成功合併",
      "ERROR_MESSAGE": "無法合併聯絡人，請重試！"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "聯絡人",
      "SEARCH_TITLE": "搜尋聯絡人",
      "ACTIVE_TITLE": "活躍聯絡人",
      "SEARCH_PLACEHOLDER": "搜尋...",
      "MESSAGE_BUTTON": "訊息",
      "SEND_MESSAGE": "傳送訊息",
      "BLOCK_CONTACT": "封鎖聯絡人",
      "UNBLOCK_CONTACT": "解除封鎖聯絡人",
      "BREADCRUMB": {
        "CONTACTS": "聯絡人"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "新增聯絡人",
          "EXPORT_CONTACT": "匯出聯絡人",
          "IMPORT_CONTACT": "匯入聯絡人",
          "SAVE_CONTACT": "儲存聯絡人",
          "EMAIL_ADDRESS_DUPLICATE": "此電子信箱已被其他聯絡人使用。",
          "PHONE_NUMBER_DUPLICATE": "此電話號碼已被其他聯絡人使用。",
          "SUCCESS_MESSAGE": "聯絡人儲存成功",
          "ERROR_MESSAGE": "無法儲存聯絡人，請稍後再試。"
        },
        "BLOCK_SUCCESS_MESSAGE": "此聯絡人已成功封鎖",
        "BLOCK_ERROR_MESSAGE": "無法封鎖聯絡人，請稍後再試。",
        "UNBLOCK_SUCCESS_MESSAGE": "此聯絡人已成功解除封鎖",
        "UNBLOCK_ERROR_MESSAGE": "無法解除封鎖聯絡人，請稍後再試。",
        "IMPORT_CONTACT": {
          "TITLE": "匯入聯絡人",
          "DESCRIPTION": "透過 CSV 檔案匯入聯絡人。",
          "DOWNLOAD_LABEL": "下載 CSV 範例檔案。",
          "LABEL": "CSV 檔案：",
          "CHOOSE_FILE": "選擇檔案",
          "CHANGE": "變更",
          "CANCEL": "取消",
          "IMPORT": "匯入",
          "SUCCESS_MESSAGE": "匯入完成後，您將收到電子郵件通知。",
          "ERROR_MESSAGE": "發生錯誤，請重試"
        },
        "EXPORT_CONTACT": {
          "TITLE": "匯出聯絡人",
          "DESCRIPTION": "快速匯出包含聯絡人完整資訊的 CSV 檔案",
          "CONFIRM": "匯出",
          "SUCCESS_MESSAGE": "正在匯出中，匯出檔案準備就緒後，您將收到電子郵件通知。",
          "ERROR_MESSAGE": "發生錯誤，請重試"
        },
        "SORT_BY": {
          "LABEL": "排序方式",
          "OPTIONS": {
            "NAME": "姓名",
            "EMAIL": "Email",
            "PHONE_NUMBER": "電話號碼",
            "COMPANY": "公司",
            "COUNTRY": "國家",
            "CITY": "城市",
            "LAST_ACTIVITY": "最後活動",
            "CREATED_AT": "建立時間"
          }
        },
        "ORDER": {
          "LABEL": "排序順序",
          "OPTIONS": {
            "ASCENDING": "升冪",
            "DESCENDING": "降冪"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "您要儲存此篩選條件嗎？",
            "CONFIRM": "儲存篩選條件",
            "LABEL": "名稱",
            "PLACEHOLDER": "請輸入篩選條件名稱",
            "ERROR": "請輸入有效的名稱",
            "SUCCESS_MESSAGE": "篩選條件已成功儲存",
            "ERROR_MESSAGE": "無法儲存篩選條件，請稍後再試。"
          },
          "DELETE_SEGMENT": {
            "TITLE": "確認刪除",
            "DESCRIPTION": "您確定要刪除此篩選條件嗎？",
            "CONFIRM": "是，刪除",
            "CANCEL": "不，取消",
            "SUCCESS_MESSAGE": "篩選條件已成功刪除",
            "ERROR_MESSAGE": "無法刪除篩選條件，請稍後再試。"
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "顯示第 {startItem} - {endItem} 筆，共 {totalItems} 位聯絡人 | 顯示第 {startItem} - {endItem} 筆，共 {totalItems} 位聯絡人"
    },
    "FILTER": {
      "NAME": "姓名",
      "EMAIL": "Email",
      "PHONE_NUMBER": "電話號碼",
      "IDENTIFIER": "識別碼",
      "COUNTRY": "國家",
      "CITY": "城市",
      "COMPANY": "公司",
      "CREATED_AT": "建立時間",
      "LAST_ACTIVITY": "最後活動",
      "REFERER_LINK": "來源連結",
      "BLOCKED": "已封鎖",
      "BLOCKED_TRUE": "是",
      "BLOCKED_FALSE": "否",
      "BUTTONS": {
        "CLEAR_FILTERS": "清除篩選條件",
        "UPDATE_SEGMENT": "更新區段",
        "APPLY_FILTERS": "套用篩選條件",
        "ADD_FILTER": "新增篩選條件"
      },
      "TITLE": "篩選聯絡人",
      "EDIT_SEGMENT": "編輯區段",
      "SEGMENT": {
        "LABEL": "區段名稱",
        "INPUT_PLACEHOLDER": "請輸入區段名稱"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} 個篩選條件",
        "CLEAR_FILTERS": "清除篩選條件"
      }
    },
    "CARD": {
      "OF": "/",
      "VIEW_DETAILS": "查看詳細資訊",
      "EDIT_DETAILS_FORM": {
        "TITLE": "編輯聯絡人資訊",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "請輸入名字"
          },
          "LAST_NAME": {
            "PLACEHOLDER": "請輸入姓氏"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "請輸入電子信箱地址",
            "DUPLICATE": "此電子信箱已被其他聯絡人使用。"
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "請輸入電話號碼",
            "DUPLICATE": "此電話號碼已被其他聯絡人使用。"
          },
          "CITY": {
            "PLACEHOLDER": "請輸入城市名稱"
          },
          "COUNTRY": {
            "PLACEHOLDER": "選擇國家"
          },
          "BIO": {
            "PLACEHOLDER": "請輸入簡介"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "請輸入公司名稱"
          }
        },
        "UPDATE_BUTTON": "更新聯絡人",
        "SUCCESS_MESSAGE": "聯絡人已成功更新",
        "ERROR_MESSAGE": "無法更新聯絡人，請稍後再試。"
      },
      "SOCIAL_MEDIA": {
        "TITLE": "編輯社群連結",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "新增 Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "新增 Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "新增 Instagram"
          },
          "TELEGRAM": {
            "PLACEHOLDER": "新增 Telegram"
          },
          "TIKTOK": {
            "PLACEHOLDER": "新增 TikTok"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "新增 LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "新增 Twitter"
          }
        }
      },
      "DELETE_CONTACT": {
        "MESSAGE": "此操作為永久性且不可復原。",
        "BUTTON": "立即刪除"
      }
    },
    "DETAILS": {
      "CREATED_AT": "建立於 {date}",
      "LAST_ACTIVITY": "最後活動於 {date}",
      "DELETE_CONTACT_DESCRIPTION": "永久刪除此聯絡人。此操作不可復原。",
      "DELETE_CONTACT": "刪除聯絡人",
      "DELETE_DIALOG": {
        "TITLE": "確認刪除",
        "DESCRIPTION": "您確定要刪除此聯絡人嗎？",
        "CONFIRM": "是，刪除",
        "API": {
          "SUCCESS_MESSAGE": "聯絡人已成功刪除",
          "ERROR_MESSAGE": "無法刪除聯絡人，請稍後再試。"
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "無法上傳頭像，請稍後再試。",
          "SUCCESS_MESSAGE": "頭像已成功上傳"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "頭像已成功刪除",
          "ERROR_MESSAGE": "無法刪除頭像，請稍後再試。"
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "屬性",
        "HISTORY": "歷史紀錄",
        "NOTES": "備註",
        "MEDIA": "媒體",
        "MERGE": "合併"
      },
      "HISTORY": {
        "EMPTY_STATE": "此聯絡人沒有關聯的歷史對話"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "搜尋屬性",
        "UNUSED_ATTRIBUTES": "{count} 個已使用屬性 | {count} 個未使用屬性",
        "EMPTY_STATE": "此帳戶中沒有可用的聯絡人自訂屬性。您可以在設定中建立自訂屬性。",
        "YES": "是",
        "NO": "否",
        "TRIGGER": {
          "SELECT": "選擇值",
          "INPUT": "輸入值"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "無效的數字",
          "REQUIRED": "請輸入有效的值",
          "INVALID_INPUT": "無效的輸入",
          "INVALID_URL": "無效的 URL",
          "INVALID_DATE": "無效的日期"
        },
        "NO_ATTRIBUTES": "查無屬性",
        "API": {
          "SUCCESS_MESSAGE": "屬性已成功更新",
          "DELETE_SUCCESS_MESSAGE": "屬性已成功刪除",
          "UPDATE_ERROR": "無法更新屬性，請稍後再試",
          "DELETE_ERROR": "無法刪除屬性，請稍後再試"
        }
      },
      "MERGE": {
        "TITLE": "合併聯絡人",
        "DESCRIPTION": "將兩個個人檔案合併為一個，包含所有屬性和對話。如有衝突，將以主要聯絡人的屬性為準。",
        "PRIMARY": "主要聯絡人",
        "PRIMARY_HELP_LABEL": "將被保留",
        "PRIMARY_REQUIRED_ERROR": "請先選擇要合併的聯絡人再繼續",
        "PARENT": "將被合併",
        "PARENT_HELP_LABEL": "將被刪除",
        "EMPTY_STATE": "找不到聯絡人",
        "PLACEHOLDER": "搜尋主要聯絡人",
        "SEARCH_PLACEHOLDER": "搜尋聯絡人",
        "SEARCH_ERROR_MESSAGE": "無法搜尋聯絡人，請稍後再試。",
        "SUCCESS_MESSAGE": "聯絡人已成功合併",
        "ERROR_MESSAGE": "無法合併聯絡人，請重試！",
        "IS_SEARCHING": "搜尋中...",
        "BUTTONS": {
          "CANCEL": "取消",
          "CONFIRM": "合併聯絡人"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "新增備註",
        "WROTE": "撰寫了",
        "YOU": "您",
        "SAVE": "儲存備註",
        "ADD_NOTE": "新增聯絡人備註",
        "EXPAND": "展開",
        "COLLAPSE": "收合",
        "NO_NOTES": "尚無備註，您可以從聯絡人詳細資訊頁面新增備註。",
        "EMPTY_STATE": "此聯絡人尚無備註。您可以在上方輸入框中新增備註。",
        "CONVERSATION_EMPTY_STATE": "尚無備註。使用新增備註按鈕來建立一個。"
      }
    },
    "EMPTY_STATE": {
      "TITLE": "此帳戶中找不到聯絡人",
      "SUBTITLE": "點選下方按鈕開始新增聯絡人",
      "BUTTON_LABEL": "新增聯絡人",
      "SEARCH_EMPTY_STATE_TITLE": "找不到符合條件的聯絡人 🔍",
      "LIST_EMPTY_STATE_TITLE": "此檢視中沒有可用的聯絡人 📋",
      "ACTIVE_EMPTY_STATE_TITLE": "目前沒有活躍的聯絡人 🌙"
    },
    "LOAD_MORE": "載入更多"
  },
  "CONTACTS_BULK_ACTIONS": {
    "ASSIGN_LABELS": "指派標籤",
    "REMOVE_LABELS": "Remove Labels",
    "ASSIGN_LABELS_SUCCESS": "標籤已成功指派。",
    "ASSIGN_LABELS_FAILED": "指派標籤失敗",
    "REMOVE_LABELS_SUCCESS": "Labels removed successfully.",
    "REMOVE_LABELS_FAILED": "Failed to remove labels",
    "DESCRIPTION": "選擇您要新增到所選聯絡人的標籤。",
    "NO_LABELS_FOUND": "尚無可用的標籤。",
    "SELECTED_COUNT": "已選取 {count} 個",
    "CLEAR_SELECTION": "清除選取",
    "SELECT_ALL": "全選（{count}）",
    "DELETE_CONTACTS": "刪除",
    "DELETE_SUCCESS": "聯絡人已成功刪除。",
    "DELETE_FAILED": "刪除聯絡人失敗。",
    "DELETE_DIALOG": {
      "TITLE": "刪除所選聯絡人",
      "SINGULAR_TITLE": "刪除所選聯絡人",
      "DESCRIPTION": "此操作將永久刪除 {count} 位所選聯絡人。此操作無法復原。",
      "SINGULAR_DESCRIPTION": "此操作將永久刪除所選聯絡人。此操作無法復原。",
      "CONFIRM_MULTIPLE": "刪除聯絡人",
      "CONFIRM_SINGLE": "刪除聯絡人"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "無法完成搜尋，請重試。"
    },
    "FORM": {
      "GO_TO_CONVERSATION": "查看",
      "SUCCESS_MESSAGE": "訊息已成功傳送！",
      "ERROR_MESSAGE": "建立對話時發生錯誤，請稍後再試。",
      "NO_INBOX_ALERT": "沒有可用的收件匣來與此聯絡人發起對話。",
      "CONTACT_SELECTOR": {
        "LABEL": "收件人：",
        "TAG_INPUT_PLACEHOLDER": "請輸入至少 2 個字元以搜尋姓名、電子信箱或電話號碼",
        "CONTACT_CREATING": "正在建立聯絡人..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "透過：",
        "BUTTON": "顯示收件匣"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "主旨：",
        "SUBJECT_PLACEHOLDER": "請在此輸入電子郵件主旨",
        "CC_LABEL": "副本：",
        "CC_PLACEHOLDER": "請輸入至少 2 個字元以搜尋電子信箱",
        "BCC_LABEL": "密件副本：",
        "BCC_PLACEHOLDER": "請輸入至少 2 個字元以搜尋電子信箱",
        "BCC_BUTTON": "密件副本"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "在此填寫您的訊息..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "選擇範本",
        "SEARCH_PLACEHOLDER": "搜尋範本",
        "EMPTY_STATE": "查無範本",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp 範本：{templateName}",
          "VARIABLES": "變數",
          "BACK": "返回",
          "SEND_MESSAGE": "傳送訊息"
        }
      },
      "TWILIO_OPTIONS": {
        "LABEL": "選擇範本",
        "SEARCH_PLACEHOLDER": "搜尋範本",
        "EMPTY_STATE": "查無範本",
        "TEMPLATE_PARSER": {
          "BACK": "返回",
          "SEND_MESSAGE": "傳送訊息"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "捨棄",
        "SEND": "傳送（{keyCode}）"
      }
    }
  }
}
